module.exports = __webpack_public_path__ + "src/images/measurements/inseam.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/inseam.jpg
// module id = 1150
// module chunks = 0